import { Disclosure } from "@headlessui/react"
import { ChevronUpIcon } from "@heroicons/react/20/solid"

function MyDisclosure({ name, content }) {
  return (
    <Disclosure>
      <div className="flex">
        <Disclosure.Button className="inline">{name}</Disclosure.Button>
        <ChevronUpIcon className="inline h-10" />
      </div>
      <Disclosure.Panel>{content}</Disclosure.Panel>
    </Disclosure>
  )
}

export default MyDisclosure
